// AQ-10 answers (Round 2): each of the four answers is now saved as its own value
// (0 Definitely disagree, 1 Slightly disagree, 2 Slightly agree, 3 Definitely agree). Before, the two
// "disagree" answers were both 0 and the two "agree" answers both 1, so the strength wasn't kept.
// A form that saves this way has response_scale in its settings; every save and submit says which scale
// its answers use, so old answers are never read the new way.
export const AQ10_SCALE = "aq10-4";

export function scaleOf(config) {
  return (config && config.response_scale) || null;
}

// Answers saved on this device before the change: 0 becomes Definitely disagree (0) and 1 becomes
// Definitely agree (3). The direction (and so the score) is kept; the strength is a best guess, so the
// family is asked to check those answers. Returns { responses, checkIds }.
export function upgradeSavedAnswers(config, saved) {
  const responses = { ...((saved && saved.responses) || {}) };
  if (scaleOf(config) !== AQ10_SCALE || (saved && saved.responseScale === AQ10_SCALE)) {
    return { responses, checkIds: [] };
  }
  const ids = new Set(((config && config.items) || []).map((it) => String(it.id)));
  const checkIds = [];
  Object.keys(responses).forEach((k) => {
    if (!ids.has(String(k))) return;
    const v = responses[k];
    if (v === 0 || v === "0") { responses[k] = 0; checkIds.push(String(k)); }
    else if (v === 1 || v === "1") { responses[k] = 3; checkIds.push(String(k)); }
  });
  return { responses, checkIds };
}

export const CHECK_MESSAGE =
  "We've changed how this questionnaire saves answers. Your earlier answers now show as \"Definitely agree\" or \"Definitely disagree\". Please check each one marked below.";
